import { apiGet, apiPost } from "./client.js";
import type { WizardState, WizardStepName, WizardOutcome } from "./types.js";

export interface AdvanceStepRequest {
  step: WizardStepName;
  outcome: WizardOutcome;
  data?: Record<string, unknown>;
}

export interface AdvanceStepResponse {
  ok: boolean;
  state: WizardState;
}

interface RawWizardStep {
  step: WizardStepName;
  outcome: WizardOutcome;
  completed_at: string | null;
  data: Record<string, unknown> | null;
}

interface RawWizardState {
  website_id: string;
  org_id: string;
  current_step: WizardStepName;
  steps: RawWizardStep[];
  completed: number;
  created_at: string;
  updated_at: string;
}

function transformWizardState(raw: RawWizardState): WizardState {
  return {
    websiteId: raw.website_id,
    orgId: raw.org_id,
    currentStep: raw.current_step,
    steps: raw.steps.map((s) => ({
      step: s.step,
      outcome: s.outcome,
      completedAt: s.completed_at,
      data: s.data,
    })),
    completed: raw.completed === 1,
    createdAt: raw.created_at,
    updatedAt: raw.updated_at,
  };
}

export async function getWizardState(websiteId: string): Promise<WizardState> {
  const raw = await apiGet<RawWizardState>(`/websites/${websiteId}/wizard`);
  return transformWizardState(raw);
}

export async function advanceWizardStep(
  websiteId: string,
  req: AdvanceStepRequest,
): Promise<AdvanceStepResponse> {
  const raw = await apiPost<{ ok: boolean; state: RawWizardState }>(
    `/websites/${websiteId}/wizard/step`,
    req,
  );
  return {
    ok: raw.ok,
    state: transformWizardState(raw.state),
  };
}
